import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout() {
  const pageName = window.location.pathname.split("/")[1] || "home";
  return (
    <div
      id="page"
      className={pageName === "home" ? "home" : "" + pageName}
    >
      <Nav />
      <Outlet />
      <Footer />
    </div>
  );
}
